import axios, { AxiosResponse } from "axios"
import { request } from "../../request"
import { DealershipRequestResponse } from "./types"
import { getGroupId } from "../../../utils/group-utils"

// const BASE_DEALERSHIP_URL = `https://lookers-content-delivery.uat.lookers.uk` // for local dev purposes
const BASE_DEALERSHIP_URL = `${window.location.origin}`

interface ILocation {
  longitude: number
  latitude: number
}

const buildDealershipByGroupURL = (location: ILocation, groupId: string, brand?: string) => {
  const idAsInt = parseInt(groupId);
  const groupIdForQuery = getGroupId(idAsInt);
  const isCharlesHurst = idAsInt === 2;

  const { longitude, latitude } = location
  return `${BASE_DEALERSHIP_URL}/api/dealershipsearch?latitude=${latitude}&longitude=${longitude}&serviceId=d959cd45-36c9-4e52-a527-524bf3f1ee7e&radius=2000&GroupId=${groupIdForQuery}${brand && !isCharlesHurst ? `&brandName=${brand}`: ""}`
}

export const getDealerships = async (): Promise<
  AxiosResponse<DealershipRequestResponse.RootObject>
> => {
  return request({
    url: "/api/dealership-index",
    method: "get",
    headers: {
      "Access-Control-Allow-Origin": "*",
    },
  })
}

export const getDealershipsByGroup = async (
  location: ILocation,
  groupId: string,
  brand?: string
) => {
  const dealershipURL = buildDealershipByGroupURL(location, groupId, brand)
  return axios.get(dealershipURL)
}
